import React from 'react';
import Player from '@peoplenet/vi-components-ui/src/Player/container/Player';

const player = () => {
  return (
    <div className="bodycontent">
      <Player />
    </div>
  );
};

export default player;
